import { useCallback, useEffect } from 'react';

interface UseOutsideAlerterProps {
  ref: React.MutableRefObject<any>;
  callback: () => void;
  withScroll?: boolean;
  // Клики внутри элемента, подходящего под этот селектор (например, портал
  // модалки `#popup-root`), не считаются кликом снаружи.
  excludeSelector?: string;
}

const useOutsideAlerter = ({
  ref,
  callback,
  withScroll = false,
  excludeSelector
}: UseOutsideAlerterProps): void => {
  const handleClickOutside = useCallback(
    (event: any): void => {
      if (!ref.current || !callback) return;
      if (withScroll && event.type === 'scroll') {
        callback();
      } else if (
        event.type === 'mousedown' &&
        !ref.current.contains(event.target) &&
        !ref.current.parentNode?.contains(event.target) &&
        !(excludeSelector && event.target?.closest?.(excludeSelector))
      ) {
        callback();
      }
    },
    [ref, callback, withScroll, excludeSelector]
  );
  useEffect(() => {
    if (withScroll) {
      document.addEventListener('scroll', handleClickOutside);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      if (withScroll) {
        document.removeEventListener('scroll', handleClickOutside);
      }
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside, withScroll]);
};

export default useOutsideAlerter;
